{
	"name": "partnercard",
	"version": "2.1.15",
	"license": "MIT",
	"browserslist": [
		"> 1%",
		"not dead"
	],
	"scripts": {
		"css:sass": "sass src/scss/landing/theme.scss:src/css/theme.css src/scss/landing/custom.scss:src/css/custom.css --style=compressed",
		"css": "npm run css:sass && tailwindcss -i ./src/css/tailwind.css -o ./src/css/main.css --minify",
		"css:watch": "sass src/scss/landing/theme.scss:src/css/theme.css src/scss/landing/custom.scss:src/css/custom.css --style=compressed --watch",
		"prestart": "npm run css",
		"prebuild": "npm run css",
		"start": "parcel serve ./src/*.html",
		"build": "parcel build ./src/*.html --dist-dir build --no-cache",
		"test": "parcel build ./src/*.html --dist-dir test --no-cache --no-content-hash"
	},
	"staticFiles": [
		{
			"staticPath": "public"
		}
	],
	"devDependencies": {
		"@parcel/packager-raw-url": "^2.8.0",
		"@parcel/transformer-jsonld": "^2.8.0",
		"@parcel/transformer-sass": "^2.8.0",
		"@tailwindcss/cli": "^4.1.11",
		"parcel": "^2.8.0",
		"parcel-reporter-static-files-copy": "^1.5.0",
		"posthtml-doctype": "^1.1.1",
		"posthtml-include": "^1.7.4",
		"react": "^18.2.0",
		"react-dom": "^18.2.0",
		"sass": "^1.89.2"
	},
	"dependencies": {
		"iban": "^0.0.14",
		"react-input-mask": "^3.0.0-alpha.2",
		"semantic-ui-css": "^2.5.0",
		"semantic-ui-react": "^2.1.4"
	}
}
